import FileDTO, { IFile } from "./FileDTO"
import { PrintFormats, mediaPreferenceKey, printerPreferenceKey, qualityPreferenceKey } from "../planningTool/DTO/PrintFormats"

export enum PreferenceType {
  boolean,
  text,
  code,
  date,
  file,
  number,
  line,
}

export interface IPreferenceValue {
  id: number,
  value1: string,
  value2: string,
  start: {date: string} | null,
  end: {date: string} | null,
  file: IFile,
}

export interface IPreference {
  id: number,
  key1: string,
  key2: string,
  values: IPreferenceValue[],
  kind: string,
}



export type Preference = {
  id?: number,
  name: string,
  key1: string,
  key2: string,
  values: PreferenceValue[],
  kind: string, // Which part of preferences is this in?
  type: PreferenceType, // WHich type of value?
  standard: string,
  description?: string,
  page?: number,
  encrypt?: boolean,
}

export type PreferenceValue = {
  id?: number,
  value1: string,
  value2: string,
  start: Date | null,
  end: Date | null,
  file: FileDTO | null,
  encrypt?: boolean,
}

export type PreferenceCategorie = {
  name: string,
  version: 'core' | 'workbook' | 'both',
  preferences: Preference[]
}

export const prefs: PreferenceCategorie[] = [
  {
    name: 'User',
    version: 'both',
    preferences: [
      {
        name: 'Admin E-Mail Adresse',
        key1: 'systemMail',
        key2: 'adminMail',
        values: [],
        kind: 'default',
        type: PreferenceType.line,
        description: `<p>An diese Adresse werden Informationen über neue User geschickt</p>`,
        standard: ``,
      },
      {
        name: 'E-Mail Transport',
        key1: 'systemMail',
        key2: 'smtpTransport',
        values: [],
        kind: 'default',
        type: PreferenceType.line,
        description: `<p>Hier müssen wir einen String schreiben, der zum Anmelden beim E-Mail Server gebraucht wird. Dies ist die FORM:</p>
        <pre>'smtp://{SMTP_USER}:{SMTP_PASSWORD}@{SMTP_SERVER}:{SMTP_PORT}</pre>
        <p>Alles in den geschweiften Klammern muss durch die passenden Werte ersetzt werden</p>
        <p>Wenn das Feld leer ist, so wird der digital@lubbers.de verwendet - wenn die E-Mailadresse hier nicht passt, dann klappt das senden der Mails nicht.</p>
        <p>Dieser Wert wird in der Datenbank verschlüsselt gespeichert.</p>`,
        standard: '',
        encrypt: true,
      },
      {
        name: 'Einladungs Mail an User',
        key1: 'systemMail',
        key2: 'sendManualRegisterEmailSubject',
        values: [],
        kind: 'default',
        type: PreferenceType.line,
        description: `Subject`,
        standard: `Leadership Essentials // Registrierung bestätigen`,
      },
      {
        name: '',
        key1: 'systemMail',
        key2: 'sendManualRegisterEmailBody',
        values: [],
        kind: 'default',
        type: PreferenceType.text,
        description: `<p>Mail, die durch den Admin ausgelöst wird, wenn er Personen ins Portal einlädt.</p>
<p>Diese Mail wird auch geschickt, wenn ein User sein Passwort zurücksetzen möchte</p>
<p>Platzhalter einbauen:<ul>
<li><pre class='w3-show-inline-block'>{registerUrl}</pre> - Link zum Registrierungsprozess</li>
</ul></p>`,
        standard: `<p class="MsoPlainText">
  Hi,<o:p></o:p>
  <p>hiermit startest du den Registrierungsprozess.</p>
  <p><a href="{registerUrl}">Bitte folge dazu diesem Link</a></p>
  <p>Wenn du keinen Registrierungsprozess bei uns gestartet hast, ignoriere diese E-Mail.</p>
  <p>Viele Grüße,</p>
  <p>Team lubbers</p>
</p>`,
        
      },
      {
        name: 'Registrierung/Passwort Erfolgs Mail an User',
        key1: 'systemMail',
        key2: 'sendPasswordChangedEmailBody',
        values: [],
        kind: 'default',
        type: PreferenceType.text,
        description: `<p>Mail an User, dass die Registrierung erfolgreich war.</p>`,
        standard: `<p class="MsoPlainText">Hi,<o:p></o:p>
</p>
<p class="MsoPlainText">
    <o:p>&nbsp;</o:p>
</p>
<p class="MsoPlainText">Sehr gut <span style="font-family:&quot;Segoe UI Emoji&quot;,sans-serif">🎉</span><br><br>
    Deine Registrierung war erfolgreich. <span style="font-family:&quot;Segoe UI Emoji&quot;,sans-serif">👍</span>
    <o:p></o:p>
</p>
<p class="MsoPlainText">
    <o:p>&nbsp;</o:p>
</p>
<p class="MsoPlainText">Wenn du auf den folgenden Link klickst, gelangst du zur Login-Seite: <a href="https://workbook.lubbers.de/view=login">https://workbook.lubbers.de/view=login</a><o:p></o:p>
</p>
<p class="MsoPlainText">
    <o:p>&nbsp;</o:p>
</p>
<p class="MsoPlainText">Tipp 1: Dein Benutzername ist immer deine E-Mail-Adresse<o:p></o:p>
</p>
<p class="MsoPlainText">Tipp 2: Speichere die Login-Seite in deinen Favoriten. So hast du immer einen schnellen Zugriff auf das System.<o:p></o:p>
</p>
<p class="MsoPlainText">
    <o:p>&nbsp;</o:p>
</p>
<p class="MsoPlainText">Solltest du Fragen oder Ideen zu unserer Plattform haben oder Unterstützung brauchen, dann melde dich gerne bei
    <a href="mailto:patrick.lubbers@lubbers.de">patrick.lubbers@lubbers.de</a>
    <o:p></o:p>
</p>
<p class="MsoPlainText">
    <o:p>&nbsp;</o:p>
</p>
<p class="MsoPlainText">Herzliche Grüße wünscht dir das lubbers Team und<o:p></o:p>
</p>

<p class="MsoNormal" style="margin-bottom:12.0pt"><b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Patrick</span></b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">
    <br>
    <br>
    <a href="https://teams.microsoft.com/l/chat/0/0?users=patrick.lubbers@lubbers.de"><span style="color:#0563C1">Chat with me</span></a> on Microsoft Teams<br>
    <a href="https://www.linkedin.com/in/patrick-lubbers/"><span style="color:#0563C1">Follow me</span></a> on LinkedIn<br>
    <br>
    ---<o:p></o:p></span>
</p>

<p class="MsoNormal"><b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Bleiben wir in Kontakt?<br>
</span></b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Über die folgenden Unternehmenskanäle informieren wir regelmäßig über Produktneuheiten,
<br>
Termine zu offenen Veranstaltungen, Rabattaktionen, neue Wissensinhalte und unser Unternehmen.<br>
<br>
<span style="color:#0070C0"><a href="https://lubbers.de/ueber-uns/newsletter-anmeldung"><span style="color:#0070C0">Newsletter</span></a></span>,
<span style="color:#0070C0"><a href="https://www.linkedin.com/company/27024653/"><span style="color:#0070C0">LinkedIn</span></a></span>,
<span style="color:#0070C0"><a href="https://www.facebook.com/teamlubbers"><span style="color:#0070C0">Facebook</span></a></span>
<o:p></o:p>
</span></p>
<p class="MsoNormal" style="margin-bottom:12.0pt"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE"><br>
---<o:p></o:p></span></p>
<p class="MsoNormal" style="margin-bottom:12.0pt"><b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">lubbers GmbH</span></b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE"><br>
Drieschweg 13<br>
53604 Bad Honnef</span><span style="font-size:12.0pt;mso-fareast-language:DE">
<o:p></o:p>
</span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">+49 (0) 2224 98984 - 0 &nbsp;(Zentrale)<br>
+49 (0) 2224 98984 - 20 (Fax)<o:p></o:p></span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">+49 (0) 171 6707039 (Persönlich)<br>
<br>
<span style="color:#0070C0"><a href="mailto:patrick.lubbers@lubbers.de"><span style="color:#0070C0">patrick.lubbers@lubbers.de</span></a><br>
    <a href="http://www.lubbers.de/"><span style="color:#0070C0">www.lubbers.de</span></a>
    <o:p></o:p>
</span></span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">
<o:p>&nbsp;</o:p>
</span></p>
<p class="MsoNormal" style="margin-bottom:12.0pt"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE"><br>
Geschäftsführer: Patrick Lubbers, Gerd Jurczyk<o:p></o:p></span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Amtsgericht Siegburg<br>
HRB 17923</span></p>
`,
      },
      {
        name: 'Passwort Setzen Mail an User',
        key1: 'systemMail',
        key2: 'sendRegisterEmailBody',
        values: [],
        kind: 'default',
        type: PreferenceType.text,
        description: `<p>Mail an Nutzer, welche zum Setzen des Passworts auffordert.</p>
  <p>Auslöser</p>
  <ul>
  <li>Beim Registrieren</li>
  <li>Durch klick des Administrators</li>
  <li>Beim Klick auf "Passwort vergessen"</li>
</ul>
<p>Platzhalter einbauen:<ul>
<li><pre class='w3-show-inline-block'>{registerUrl}</pre> - Link zum Registrierungsprozess</li>
</ul></p>`,
        standard: `<p class="MsoPlainText">Hi,<o:p></o:p>
</p>
<p class="MsoPlainText">
    <o:p>&nbsp;</o:p>
</p>
<p class="MsoPlainText">
    zum setzen des Passworts folge diesem Link: <a href="{registerUrl}">{registerUrl}</a>
    <o:p></o:p>
</p>
<p class="MsoPlainText">
    <o:p>&nbsp;</o:p>
</p>
<p class="MsoPlainText"> Sobald du das Passwort gesetzt hast, bekommst du eine weitere E-Mail.</p>
<p class="MsoPlainText">
    Beachte dabei: Dein Benutzername ist immer deine E-Mail-Adresse.
</p>
<p class="MsoPlainText"><b>Wir freuen uns über dein Feedback</b><br>
    Ist dir etwas positiv oder negativ aufgefallen? Hast du Ideen für dieses System? Wir hören dir gerne zu. Melde dich einfach direkt bei <a href="mailto:patrick.lubbers@lubbers.de">patrick.lubbers@lubbers.de</a>.<o:p></o:p>
</p>
<p class="MsoPlainText">Herzliche Grüße wünscht dir das lubbers Team und
</p>

<p class="MsoNormal" style="margin-bottom:12.0pt"><b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Patrick</span></b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">
    <br>
    <br>
    <a href="https://teams.microsoft.com/l/chat/0/0?users=patrick.lubbers@lubbers.de"><span style="color:#0563C1">Chat with me</span></a> on Microsoft Teams<br>
    <a href="https://www.linkedin.com/in/patrick-lubbers/"><span style="color:#0563C1">Follow me</span></a> on LinkedIn<br>
    <br>
    ---<o:p></o:p></span>
</p>

<p class="MsoNormal"><b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Bleiben wir in Kontakt?<br>
</span></b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Über die folgenden Unternehmenskanäle informieren wir regelmäßig über Produktneuheiten,
<br>
Termine zu offenen Veranstaltungen, Rabattaktionen, neue Wissensinhalte und unser Unternehmen.<br>
<br>
<span style="color:#0070C0"><a href="https://lubbers.de/ueber-uns/newsletter-anmeldung"><span style="color:#0070C0">Newsletter</span></a></span>,
<span style="color:#0070C0"><a href="https://www.linkedin.com/company/27024653/"><span style="color:#0070C0">LinkedIn</span></a></span>,
<span style="color:#0070C0"><a href="https://www.facebook.com/teamlubbers"><span style="color:#0070C0">Facebook</span></a></span>
<o:p></o:p>
</span></p>
<p class="MsoNormal" style="margin-bottom:12.0pt"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE"><br>
---<o:p></o:p></span></p>
<p class="MsoNormal" style="margin-bottom:12.0pt"><b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">lubbers GmbH</span></b><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE"><br>
Drieschweg 13<br>
53604 Bad Honnef</span><span style="font-size:12.0pt;mso-fareast-language:DE">
<o:p></o:p>
</span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">+49 (0) 2224 98984 - 0 &nbsp;(Zentrale)<br>
+49 (0) 2224 98984 - 20 (Fax)<o:p></o:p></span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">+49 (0) 171 6707039 (Persönlich)<br>
<br>
<span style="color:#0070C0"><a href="mailto:patrick.lubbers@lubbers.de"><span style="color:#0070C0">patrick.lubbers@lubbers.de</span></a><br>
    <a href="http://www.lubbers.de/"><span style="color:#0070C0">www.lubbers.de</span></a>
    <o:p></o:p>
</span></span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">
<o:p>&nbsp;</o:p>
</span></p>
<p class="MsoNormal" style="margin-bottom:12.0pt"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE"><br>
Geschäftsführer: Patrick Lubbers, Gerd Jurczyk<o:p></o:p></span></p>
<p class="MsoNormal"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:DE">Amtsgericht Siegburg<br>
HRB 17923</span></p>
`,
      },
      {
        name: 'Selbstregistrierung - Mail an Admin',
        key1: 'systemMail',
        key2: 'sendUserWantsToRegisterMailSubject',
        values: [],
        kind: 'default',
        type: PreferenceType.line,
        description: `Subject`,
        standard: `Leadership Essentials // Person möchte registrieren`,
      },
      {
        name: '',
        key1: 'systemMail',
        key2: 'sendUserWantsToRegisterMailBody',
        values: [],
        kind: 'default',
        type: PreferenceType.text,
        description: `<p>Mail, die an den Admin geschickt wird, dass sich eine Person sich selbstständig registriert hat.</p>
        <p>Platzhalter einbauen:<ul>
<li><pre class='w3-show-inline-block'>{mail}</pre> - E-Mail Adresse des neuen Users</li>
</ul></p>`,
        standard: `<p class="MsoPlainText">Hi,<o:p></o:p>
<p>Folgende Person möchte sich registrieren</p>
<p>{mail}</p>
<p>Bitte im <a href="https://workbook.lubbers.de/view=userList/">Admin Bereich</a> freigeben!</p>`,
      },
    ]
  },
  {
    name: 'Shop',
    version: 'workbook',
    preferences: [
      {
        name: 'Shop aktiviert',
        key1: 'shop',
        key2: 'enable',
        values: [],
        kind: 'default',
        type: PreferenceType.boolean,
        standard: '0'
      },
      {
        name: 'Bezahl Überweisungs Anweisungstext ',
        key1: 'shop',
        key2: 'PaymentManualTransferExplainText',
        values: [],
        kind: 'default',
        type: PreferenceType.text,
        standard: '0',
        description: `<p>Platzhalter einbauen: <ul>
          <li><pre class='w3-show-inline-block'>{TOTALWITHTAX}</pre> - Höhe des zu zahlenden Betrages</li>
          <li><pre class='w3-show-inline-block'>{TAX}</pre> - Höhe der MWS</li>
          <li><pre class='w3-show-inline-block'>{CARTHASH}</pre> - Referenz Nummer zu diesem Einkauf</li>
          <li><pre class='w3-show-inline-block'>{CARTSUMMARY}</pre> - Zusammenfassun der Positionen</li>
          <li><pre class='w3-show-inline-block'>{FIRSTNAME}</pre> - Vorname (mit Vorrangehendem Leerzeichen)</li>
        </ul></p>
        `
      },
      {
        name: 'Bestätigungsmail, wenn Einkäufe dem User zugeordnet wurden:',
        key1: 'shop',
        key2: 'cartFullfilled',
        values: [],
        kind: 'default',
        type: PreferenceType.text,
        standard: '0',
        description: `<p>Platzhalter einbauen: <ul>
          <li><pre class='w3-show-inline-block'>{TOTALWITHTAX}</pre> - Höhe des zu zahlenden Betrages</li>
          <li><pre class='w3-show-inline-block'>{TAX}</pre> - Höhe der MWS</li>
          <li><pre class='w3-show-inline-block'>{CARTHASH}</pre> - Referenz Nummer zu diesem Einkauf</li>
          <li><pre class='w3-show-inline-block'>{CARTSUMMARY}</pre> - Zusammenfassun der Positionen</li>
          <li><pre class='w3-show-inline-block'>{FIRSTNAME}</pre> - Vorname (mit Vorrangehendem Leerzeichen)</li>
        </ul></p>
        `
      },
    ]
  },
  {
    name: 'Buchlayout',
    version: 'workbook',
    preferences: [
      {
        name: 'Standardlayout 2021-09',
        key1: 'booklayout',
        key2: 'standard-theme-2021-09',
        values: [],
        kind: 'default',
        type: PreferenceType.code,
        standard: '',
        description: `<p>Hier kann man CSS Code einfügen, der den original-Code überschreibt.</p>`
      },
    ]
  },
  {
    name: 'Nutzererlebnis',
    version: 'workbook',
    preferences: [
      {
        name: 'Nutzer sammeln beim Erhalt eines Buches sofort alle Karten',
        key1: 'collectable',
        key2: 'instantCollectOnBookReceive',
        values: [],
        kind: 'default',
        type: PreferenceType.boolean,
        standard: '0'
      },
    ]
  },
  {
    name: 'Druck',
    version: 'core',
    preferences: [
      {
        name: 'QZ-Zertifikat',
        key1: 'print',
        key2: 'qzCertificate',
        values: [],
        kind: 'default',
        type: PreferenceType.code,
        standard: '',
        description: `<p>Öffentliches Zertifikat (PEM). Dasselbe Zertifikat in QZ Tray unter Site Manager hinterlegen. Nach dem Speichern die Seite neu laden.</p>`,
      },
      {
        name: 'QZ privater Schlüssel',
        key1: 'print',
        key2: 'qzPrivateKey',
        values: [],
        kind: 'default',
        type: PreferenceType.code,
        standard: '',
        encrypt: true,
        description: `<p>Privater Schlüssel (PEM) zum Signieren der QZ-Anfragen. Wird verschlüsselt gespeichert und nicht an den Browser gegeben.</p>`,
      },
      ...PrintFormats.flatMap(format => ([
        {
          name: `Drucker: ${format.title}`,
          key1: 'print',
          key2: printerPreferenceKey(format.value),
          values: [],
          kind: 'default',
          type: PreferenceType.line,
          standard: '',
          description: `<p>Exakter Druckername aus QZ Tray für ${format.title} (${format.widthMm} × ${format.heightMm} mm).</p>`,
        },
        {
          name: `Medienname: ${format.title}`,
          key1: 'print',
          key2: mediaPreferenceKey(format.value),
          values: [],
          kind: 'default',
          type: PreferenceType.line,
          standard: format.defaultMedia || '',
          description: `<p>Papiername im Treiber, z. B. A6. Leer nutzt ${format.defaultMedia ? `den Standard „${format.defaultMedia}“` : 'Millimeter'}. Millimeter-Sondergrößen sind am Treiber oft unzuverlässig.</p>`,
        },
        {
          name: `Qualität: ${format.title}`,
          key1: 'print',
          key2: qualityPreferenceKey(format.value),
          values: [],
          kind: 'default',
          type: PreferenceType.line,
          standard: '',
          description: `<p>Auflösung in dpi, z. B. 300 oder 600. Leer lässt die Qualität beim Drucker. Ein Asset kann diesen Wert überschreiben.</p>`,
        },
      ])),
    ]
  },
  
]
